import { ShieldCheck, BadgePoundSterling, FileCheck2, UserCheck } from "lucide-react";
import { Reveal, Kicker } from "./Reveal";

const FEATURES = [
  {
    icon: ShieldCheck,
    n: "01",
    title: "CDM 2015 Compliance",
    desc: "Every project is planned, resourced and delivered in full accordance with the Construction (Design & Management) Regulations 2015.",
  },
  {
    icon: BadgePoundSterling,
    n: "02",
    title: "Transparent Pricing",
    desc: "Itemised, fixed quotations with no hidden extras. You approve every cost before a single tool is lifted.",
  },
  {
    icon: FileCheck2,
    n: "03",
    title: "Insured Workmanship",
    desc: "Comprehensive public liability and employer's liability cover in place on every contract, without exception.",
  },
  {
    icon: UserCheck,
    n: "04",
    title: "Dedicated Project Management",
    desc: "One named project manager from first survey to final handover — a single, accountable point of contact.",
  },
];

export const WhyUs = () => (
  <section
    id="why-us"
    data-testid="why-us-section"
    className="border-y border-black/5 bg-coal py-24 md:py-36"
  >
    <div className="mx-auto max-w-7xl px-6">
      <div className="flex flex-col justify-between gap-8 md:flex-row md:items-end">
        <div>
          <Reveal>
            <Kicker index="05" label="Why Choose Us" />
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-display text-5xl font-bold uppercase leading-[0.95] tracking-tight text-ink md:text-6xl">
              Built on Trust.
              <span className="block text-gold-shine">Proven on Site.</span>
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.15}>
          <p className="max-w-sm text-sm leading-relaxed text-fog">
            The standards behind every Sunny Construction project — non-
            negotiable, on every contract, large or small.
          </p>
        </Reveal>
      </div>

      <div className="mt-16 grid gap-px border border-black/10 bg-black/10 sm:grid-cols-2 lg:grid-cols-4">
        {FEATURES.map((feature, i) => {
          const Icon = feature.icon;
          return (
            <Reveal key={feature.n} delay={i * 0.08} className="h-full">
              <div
                data-testid={`feature-card-${feature.n}`}
                className="group flex h-full flex-col bg-white p-8 transition-colors duration-500 hover:bg-steel"
              >
                <div className="flex items-start justify-between">
                  <div className="grid h-12 w-12 place-items-center border border-bronze/40 transition-colors duration-500 group-hover:border-ink">
                    <Icon className="h-5 w-5 text-bronze transition-colors duration-500 group-hover:text-ink" strokeWidth={1.8} />
                  </div>
                  <span className="font-display text-5xl font-extrabold text-outline">
                    {feature.n}
                  </span>
                </div>
                <h3 className="mt-10 font-display text-xl font-bold uppercase leading-tight tracking-wide text-ink">
                  {feature.title}
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-fog">
                  {feature.desc}
                </p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
